r<template>
  <modal>
    <template v-slot:header>
      <h5 class="modal-title">{{$t('form.phone-confirmation.title')}}</h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
        <span aria-hidden="true"><img src="@/assets/img/static/b-icon_close_x.svg" alt=""></span>
      </button>
    </template>

    <template v-slot:body>
      <div class="modal-body__registration">
        <p>{{$t('form.phone-confirmation.enter-code-from-sms')}}</p>
        <input type="text" class="a-input" :placeholder="$t('form.phone-confirmation.input-code-placeholder')" v-model="code">
      </div>
      <div class="a-container-form">
        <button class="gui-btn gui-btn--link" style="margin: 0 auto" @click.prevent="onResendCodeClick">
          <small>{{$t('form.phone-confirmation.request-code-again')}}</small>
        </button>
      </div>
    </template>

    <template v-slot:footer>
      <button class="gui-btn gui-btn--white-border gui-btn--ep" @click.prevent="$emit('close')" v-t="'buttons.cancel'"></button>
      <button class="gui-btn gui-btn--red gui-btn--ep" @click.prevent="onConfirmCodeClick" v-t="'buttons.confirm'"></button>
    </template>
  </modal>
</template>

<script>
  import Modal from '@/widgets/modal'

  export default {
    props: {
      eventId: {
        required: true
      }
    },

    data: () => ({
      code: undefined,
    }),

    components: {
      Modal
    },

    methods: {
      async onConfirmCodeClick() {
        try {
          const valid = await this.$store.dispatch('confirmPhoneByEventId', {
            eventId: this.eventId,
            code: this.code
          });

          if (valid) {
            this.$emit('close');

            this.showError({
              title: this.$t('form.phone-confirmation.phone-number-confirmed'),
              error: this.$t('form.phone-confirmation.log-in-with-phone-number-and-password')
            });
          }
        }
        catch(e) {
          console.error('unable to confirm phone due to error:', e);
          this.globalErrorHandler(e);
        }
      },

      async onResendCodeClick() {
        try {
          await this.$store.dispatch('resendCodeByEventId', {
            eventId: this.eventId
          });
        }
        catch(e) {
          console.error('unable to resend sms code due to error:', e);
          this.globalErrorHandler(e);
        }
      }
    }
  }
</script>

<style scoped>

</style>
